<div class="row utils-bar" [style]="'justify-content: space-between'">
  @if (dataSource) {
    <div class="table-filter">
      <input #userFilterInput  (keyup)="applyFilter(userFilterInput.value)" [value]="filterValue" placeholder="Search users"/>
    </div>
  }
</div>
<div class="table-container">
  <table [dataSource]="dataSource"
    [id]="id"
    [matSortActive]="'name'"
    (matSortChange)="applySort($event)" class="table table-striped user-table" mat-table matSort matSortDirection="asc">

    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column.title">
        <th *matHeaderCellDef [mat-sort-header]="column.name" mat-header-cell>
          @if (column.title === 'edit') {
          }
          @if (column.title !== 'edit') {
            {{column.title}}
          }
        </th>
        <td *matCellDef="let user;"
          [style]=" {'text-align':['restricted_access','active','sms_disabled','email_disabled'].includes(column.name) ? 'center' : 'left' }"
          mat-cell
          style="text-align: left;border:none;">
          @if (column.title === 'edit') {
            @if (can_edit) {
              <i (click)="openDialog(user)" class="fa fa-edit" style="cursor:pointer;"></i>
            }
          }
          @if (['restricted_access','active','sms_disabled','email_disabled'].includes(column.name)) {
            <mat-checkbox (change)="userChanged(user)" [(ngModel)]="user.attributes[column.name]"
            [disabled]="!can_edit || ['active'].includes(column.name)"></mat-checkbox>
          }
          @if (!['restricted_access','active','sms_disabled','email_disabled','edit'].includes(column.name)) {
            @if (column.name==='created_on') {
              {{user.attributes[column.name] | stringDate }}
            }
            @if (column.name==='user_activity') {
              <ul [style]="'list-style:none;padding:0;white-space: nowrap;'">
                <li>Last seen: {{user_meta_dict[user.id]?.attributes.last_seen | stringDate }}</li>
                <li>Last login: {{user_meta_dict[user.id]?.attributes.last_login | stringDate }}</li>
                <li>Last 2FA: {{user_meta_dict[user.id]?.attributes.last_2fa_activation | stringDate }}</li>
                <li>Last pwd
                reset: {{user_meta_dict[user.id]?.attributes.last_password_reset | stringDate }}</li>
              </ul>
            }
            @if (!['created_on'].includes(column.name)) {
              {{user.attributes[column.name]}}
            }
          }
        </td>
      </ng-container>
    }

    <ng-container>
      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    </ng-container>
  </table>
</div>
